import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * AI Module Service Stores
 * Updated to match backend api-types
 */
export const aiStores: ServiceStoreConfig[] = [
  {
    // create-only RPC endpoint (Methods = ['create']) — a bare find is MethodNotAllowed.
    name: "ingestion",
    options: {
      enableStorage: false,
      enableErrorNotifications: false,
      disableInitialFind: true,
    },
  },
  {
    // needs Azure AI config this tenant does not use.
    name: "nlp-service",
    options: {
      enableStorage: false,
      enableErrorNotifications: false,
      disableInitialFind: true,
    },
  },
  {
    name: "openai",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    // needs Azure OpenAI config this tenant does not use.
    name: "openai-rag",
    options: {
      enableStorage: false,
      enableErrorNotifications: false,
      disableInitialFind: true,
    },
  },
  {
    // create-only RPC endpoint (Methods = ['create']) — a bare find is MethodNotAllowed.
    name: "processing",
    options: {
      enableStorage: false,
      enableErrorNotifications: false,
      disableInitialFind: true,
    },
  },
  {
    // create-only RPC endpoint (Methods = ['create']) — a bare find is MethodNotAllowed.
    name: "querying",
    options: {
      enableStorage: false,
      enableErrorNotifications: false,
      disableInitialFind: true,
    },
  },
  {
    name: "search-query-builder",
    // unavailable in this tenant — no initial find, and no toast if one is called
    options: {
      enableStorage: false,
      enableErrorNotifications: false,
      disableInitialFind: true,
    },
  },
  {
    name: "ticket-classifier",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "universal-indexer",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    // find exists but is a vector SEARCH, not a listing — a bare find is a BadRequest.
    name: "vector-storage",
    options: {
      enableStorage: false,
      enableErrorNotifications: false,
      disableInitialFind: true,
    },
  },
];
